import { getAuth, signInWithCustomToken, signOut } from 'firebase/auth';
import { app } from '@/firebase/firebase';

export class FirebaseAuthService {
  static async signInWithToken(token: string) {
    try {
      const auth = getAuth(app);
      await signInWithCustomToken(auth, token);
    } catch (error) {
      console.warn('Firebase auth failed:', error);
    }
  }

  static signOut() {
    const auth = getAuth(app);
    signOut(auth).catch((error) => {
      console.warn('Firebase signout failed:', error);
    });
  }
}
